module.exports = __webpack_public_path__ + "img/icon_02.5dc6d330.png";